import BusinessHour from '../../domain/entities/BusinessHour';

// TODO: Refactoring
class DateTimeUtils {
  public static formatWeekday(dayNumber: number): string {
    switch (dayNumber) {
      case 0:
        return '日';
      case 1:
        return '月';
      case 2:
        return '火';
      case 3:
        return '水';
      case 4:
        return '木';
      case 5:
        return '金';
      case 6:
        return '土';
      default:
        return '';
    }
  }

  public static formatBusinessHours(businessHours: BusinessHour[]): string[] {
    const result: string[] = [];
    const weekdays = DateTimeUtils.getWeekdays(businessHours);
    const monday = weekdays[0];
    if (DateTimeUtils.isWeekdayEverySameTime(weekdays, monday)) {
      // eslint-disable-next-line no-irregular-whitespace
      result.push(
        DateTimeUtils.formatBizHourString(
          '月〜金',
          monday.openingHour,
          monday.closingHour,
        ),
      );
    } else {
      weekdays.forEach((d: BusinessHour) => {
        if (d.isOpen) {
          result.push(DateTimeUtils.formatBusinessHour(d));
        }
      });
    }

    const weekend = DateTimeUtils.getWeekend(businessHours);
    const sunday = weekend[0];
    if (DateTimeUtils.isWeekendEverySameTime(weekend, sunday)) {
      // eslint-disable-next-line no-irregular-whitespace
      result.push(
        DateTimeUtils.formatBizHourString(
          '土・日',
          sunday.openingHour,
          sunday.closingHour,
        ),
      );
    } else {
      weekend.reverse().forEach((d: BusinessHour) => {
        if (d.isOpen) {
          result.push(DateTimeUtils.formatBusinessHour(d));
        }
      });
    }

    return result;
  }

  public static getWeekdays(businessHours: BusinessHour[]) {
    return businessHours.filter(v => v.weekday > 0 && v.weekday < 6);
  }

  public static getWeekend(businessHours: BusinessHour[]) {
    return businessHours.filter(v => v.weekday === 0 || v.weekday === 6);
  }

  public static isWeekdayEverySameTime(
    weekdays: BusinessHour[],
    monday: BusinessHour,
  ) {
    return weekdays.every(
      (d: BusinessHour) =>
        d.isOpen &&
        monday.openingHour === d.openingHour &&
        monday.closingHour === d.closingHour,
    );
  }

  public static isWeekendEverySameTime(
    weekdays: BusinessHour[],
    sunday: BusinessHour,
  ) {
    return weekdays.every(
      (d: BusinessHour) =>
        d.isOpen &&
        sunday.openingHour === d.openingHour &&
        sunday.closingHour === d.closingHour,
    );
  }

  public static formatBusinessHour(date: BusinessHour): string {
    const weekday = DateTimeUtils.formatWeekday(date.weekday);
    const open = date.openingHour;
    const close = date.closingHour;
    // eslint-disable-next-line no-irregular-whitespace
    return DateTimeUtils.formatBizHourString(weekday, open, close);
  }

  private static formatBizHourString(
    week: string,
    open: string,
    close: string,
  ): string {
    return `${week}　${open.substring(0, 5)} - ${close.substring(0, 5)}\n`;
  }
}

export default DateTimeUtils;
